export default "__VITE_ASSET__cbe52675__"